__webpack_require__.p = "/reports-dashboard-templates-empty-dashboards-list/referrals-hub/";